<script setup lang="ts">
interface Props {
  isFirstPage: boolean
  prevPageUrl: string | null
  showSkeletonCount?: boolean
}
defineProps<Props>()
const { smallGrid, numberOfCards } = useProductGridOptions()
</script>

<template>
  <div
    v-if="showSkeletonCount"
    class="total-products"
    :class="{ gap: !isFirstPage && prevPageUrl }"
    aria-label="Loading the number of products"
  />
  <div
    class="product-grid"
    :class="{ 'product-grid--small': smallGrid }"
    aria-label="Loading product grid content"
  >
    <ProductGridSkeletonCard
      v-for="card in numberOfCards"
      :key="card"
    />
  </div>
</template>

<style lang="scss" scoped>
@import 'assets/scss/rules/breakpoints';

.total-products  {
    height: 2.4rem;
    margin: 1.2rem 0 1.2rem 1.6rem;
    margin-bottom: 1.2rem;
    width: 9.5rem;
    background-color: var(--gray);
    background: linear-gradient(110deg, #ececec 20%, #f5f5f5 30%, #ececec 43%);
    background-size: 200% 100%;
    animation: 1.5s loading linear infinite;

    @media (min-width: $tablet) {
        margin: 1.6rem 0 1.6rem 2.2rem;
    }

    @media (prefers-reduced-motion) {
        background: var(--gray);
        animation: none;
    }
}

.product-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    border-top: 1px solid var(--gray-light);
    border-bottom: 1px solid var(--gray-light);
    background-color: var(--gray-light);
    grid-gap: 1px;

    @media (min-width: $tablet) {
        grid-template-columns: repeat(4, 1fr);
    }

    &--small {
        border: unset;
        background-color: unset;
        grid-template-columns: repeat(auto-fit, minmax(12rem, 0.5fr));

        @media (min-width: $phablet) {
            grid-template-columns: repeat(auto-fit, minmax(15rem, 0.25fr));
        }
    }
}

@keyframes loading {
    to {
        background-position-x: -200%;
    }
}
</style>
